<ngb-alert
  [dismissible]="false"
  [id]="options().id"
  [type]="options().type!"
  [class]="options().class || ''"
>
  <div class="d-flex align-items-baseline">
    <span>
      <strong>
        <ng-content select="title">
          {{ translations.titles[options().title!] || options().title }}&#9;
        </ng-content>
      </strong>
    </span>
<!--    <span>-->
      <ng-content select="alert-body">
        {{translations[options().text!] || options().text}}
      </ng-content>
<!--    </span>-->
  </div>
</ngb-alert>
